import { useSyncExternalStore } from 'react';
import { getSyncEngine } from './engine';

export function useSyncStatus() {
  const engine = getSyncEngine();

  return useSyncExternalStore(
    engine.subscribe,
    engine.getStatus,
    engine.getStatus,
  );
}
